import {Popover, Theme, Typography} from '@material-ui/core';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import {makeStyles} from '@material-ui/styles';
import React, {useState} from 'react';
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(1),
  },
  icon: {
    color: theme.palette.primary.light,
    fontSize: 12,
  },
}));

const InfoPopover = (props: { message?: string, className?: string, children?: any }) => {
  const {message, children} = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <React.Fragment>
      <span
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        className={clsx(classes.icon)}
      >
        <HelpOutlineOutlinedIcon className={props.className} style={{fontSize: '1rem'}}/>
      </span>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{paper: classes.paper,}}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{vertical: 'bottom', horizontal: 'left',}}
        transformOrigin={{vertical: 'top', horizontal: 'left',}}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography>
          {message}
          {children}
        </Typography>
      </Popover>
    </React.Fragment>
  );
};

export default InfoPopover;
